/* unplugin-vue-components disabled */import { render } from "./CardHeader.vue?vue&type=template&id=70d0e33d&scoped=true"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"

import "./CardHeader.vue?vue&type=style&index=0&id=70d0e33d&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d0e33d"]])

export default __exports__